import { BehaviorSubject, Subject } from 'rxjs';
import { Component, OnInit } from '@angular/core';
import { MatDialog } from '@angular/material/dialog';

import { Contract } from '../../domain/data';
import { ErrorDialog } from '../../ui/dialog/error/error.dialog';
import { GetContractUseCase, GetProfileUseCase, UserInterface } from '../../../core';
import { Loader } from '../../client/helpers/loader';

import { environment } from '../../../../environments/environment';

@Component({
    templateUrl: './operative.page.html',
    styleUrls: ['./operative.page.scss'],
})
export class OperativePage implements OnInit {
    public contract: Contract;
    public user: UserInterface;
    public showBack = false;
    public showHeader = true;

    public back: Subject<boolean> = new Subject();
    public contractLoaded: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);

    public isClientPortal = environment.portalClient;

    constructor(
        private dialog: MatDialog,
        private getContractUseCase: GetContractUseCase,
        private getProfileUseCase: GetProfileUseCase,
        public loader: Loader
    ) {}

    ngOnInit() {
        this.getProfile();

    }

    private getContract() {
        this.getContractUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.contract = transaction.data as Contract;
                this.contractLoaded.next(true);

                if (this.contract.isAdvisoryModelSuitabilityOrGDC()) {
                    this.hideHeader();
                }
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog);
            }
        });
    }

    private getProfile() {
        this.getProfileUseCase.bind().subscribe((transaction) => {
            if (transaction.isSuccess) {
                this.user = transaction.data;
            } else if (!transaction.isAuthError) {
                this.dialog.open(ErrorDialog, {
                    data: { text: transaction.error },
                });
            }
             this.getContract();
        });
    }

    showBackButton() {
        this.showBack = true;
    }

    hideBackButton() {
        this.showBack = false;
    }

    hideHeader() {
        this.showHeader = false;
    }

    onBack() {
        this.back.next(true);
    }
}
